/**
 * useResponsive Hook
 *
 * Provides responsive breakpoint information and boolean checks for:
 * - Mobile: 0-575px
 * - Tablet: 576px-991px
 * - Desktop: 992px+
 *
 * Usage:
 * const { isMobile, isTablet, isDesktop, breakpoint } = useResponsive();
 *
 * if (isMobile) {
 *   // Show mobile layout
 * }
 */

import { useMediaQuery, useTheme } from '@mui/material';

export function useResponsive() {
  const theme = useTheme();

  // Mobile: 0-575px (below sm breakpoint)
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Tablet: 576px-991px (between sm and lg)
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'lg'));

  // Desktop: 992px+ (lg and above)
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  // Return a single breakpoint name for convenience
  const breakpoint = isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop';

  return {
    isMobile,
    isTablet,
    isDesktop,
    breakpoint,
  };
}

export default useResponsive;
